import React from 'react';
import './Footer.css';

const Footer = () => {
    return (
        <div>
            <p className="footer-text">Built with <span>React.js · Chart.js · GitHub Polyglot</span> and more!</p>
        </div>
    )
}

export default Footer
